// extracted by mini-css-extract-plugin
export default {"value":"StreamText_value__wx2s6","showValue":"StreamText_showValue__plRO6"};